import { SystemEvents } from '@repo/alt/Services/constants/SystemEvents.js'

import { useReviewedNow } from '../composables/useReviewedNow'

/**
 * Отметки «оценено в этой сессии» (`useReviewedNow`) принадлежат покупателю: без сброса
 * после выхода и входа другим пользователем в той же вкладке «Оценить товар» в его заказах
 * подменялось бы на «Мой отзыв». Отметки ставятся только на клиенте — там и сбрасываются.
 */
export default defineNuxtPlugin({
  name: 'reviews-reviewed-now-reset:plugin',
  dependsOn: ['eventbus-provider:plugin'],
  setup() {
    if (!import.meta.client) return

    const bus = useBus()
    const { reset } = useReviewedNow()

    bus.on(SystemEvents.LOGGED_OUT, reset)
    bus.on(SystemEvents.LOGGED_IN, reset)
  },
})
